import React from "react";
import {
  BreadcrumbContainer,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbMark,
  BreadcrumbText,
  BreadcrumbTitle,
  BreadcrumbDetail,
} from "./styles";

const CheckMark = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M5 12.5l4.5 4.5L19 7"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function InternalBreadcrumb({ stepNumber = 0, topic, award }) {
  // El paso 3 es el mensaje de postulación cargada: ahí ya no hay recorrido
  // que mostrar.
  if (stepNumber >= 3) {
    return null;
  }

  const steps = [
    {
      title: "Temática",
      detail: topic ? topic.title : "Elegí dónde participar",
    },
    {
      title: "Premio",
      detail: award ? award.title : "Elegí a qué te postulás",
    },
    {
      title: "Formulario",
      detail: "Datos y cuestionario",
    },
  ];

  return (
    <BreadcrumbContainer className="no-print" aria-label="Pasos de la postulación">
      <BreadcrumbList>
        {steps.map((step, index) => {
          const state =
            index < stepNumber
              ? "done"
              : index === stepNumber
              ? "current"
              : "todo";

          return (
            <BreadcrumbItem
              key={step.title}
              aria-current={state === "current" ? "step" : undefined}
            >
              <BreadcrumbMark $state={state}>
                {state === "done" ? <CheckMark /> : index + 1}
              </BreadcrumbMark>
              <BreadcrumbText>
                <BreadcrumbTitle $state={state}>{step.title}</BreadcrumbTitle>
                <BreadcrumbDetail>{step.detail}</BreadcrumbDetail>
              </BreadcrumbText>
            </BreadcrumbItem>
          );
        })}
      </BreadcrumbList>
    </BreadcrumbContainer>
  );
}

export const Breadcrumb = React.memo(InternalBreadcrumb);
